<template>
  <main>
    <div class="box" v-if="productInfo && Object.keys(productInfo).length">
      <section class="info">
        <!-- 左侧日历模块 -->

        <figure class="leftWrap">
          <!-- 产品图片 -->
          <el-carousel class="banner">
            <el-carousel-item v-for="(item, i) in cover_urlList" :key="i">
              <el-image class="img" :src="item" fit="cover"></el-image>
            </el-carousel-item>
          </el-carousel>

          <!-- 日历行程 -->
          <dl class="date">
            <dt>
              <nav>
                <!-- <span :class="{ on: i === submit.month }" v-for="(v, i) in tourGroups" :key="i"
                  @click="changeSubmit('month', i)">{{ v.y }}年{{ v.m + 1 }}月</span> -->
                <!-- 顶部显示 以及 控件 -->
                <div class="calendarTop ">
                  <span class="icon iconfont icon-you" @click="setLastMonth"></span>
                  <span class="dateTimeWrap">{{ show_Year }} 年 {{ show_Month }} 月</span>
                  <span class="icon iconfont icon-you" @click="setNextMonth"></span>
                </div>
              </nav>
              <p>
                <span>日</span>
                <span>一</span>
                <span>二</span>
                <span>三</span>
                <span>四</span>
                <span>五</span>
                <span>六</span>
              </p>
            </dt>
            <dd>
              <!-- 日历容器 -->
              <!-- <p v-for="(v, i) in getGroups" :key="i"
                :class="{ on: v.on, selected: submit.day && v.id === submit.day.id }" @click="changeDay(v)">
                <b>{{ v.day }}</b>
                <span>{{ v.adult_price || '' }}</span>
              </p> -->
              <p v-for="(item, index) in dayList" :key="index" @click="chooseDate(item)" class="day_Item" :class="[
                !item.day ? 'fakeDay' : '',
                selectedDate && selectedDate.date == item.date ? 'actItem' : '',
                item.price ? '' : 'none_price',
                item.isBeforeToday ? 'none_price' : ''
              ]">
                <b>{{ item.day }}</b>
                <span class="priceWrap" v-if="item.price">{{ item.price || '' }}</span>
              </p>

            </dd>
          </dl>

        </figure>
        <!-- 右侧产品详情相关 -->
        <div class="desc">
          <h3>{{ productInfo.name }}</h3>
          <p>{{ productInfo.summary }}</p>

          <!-- 选择属性 -->
          <div class="chooseProperty">
            <p class="chooseWrapTitle">选择属性</p>

            <!-- 属性值模块 -->
            <div class="skuCategoryWrap">
              <div class="sku_AttList flex-v-ss" v-for="(item, index) in sku_attribute_value" :key="index">
                <div class="attrListTitle">
                  {{ item.title }} ( {{ item.sku_attribute_values.length }} )
                  <div class="titleLine"></div>
                </div>
                <div class="attrItemGroup">
                  <div class="categotyItem" v-for="(item2, index2) in item.sku_attribute_values"
                    :class="getArrtClass(item2) ? 'categorySelected' : ''" :key="index2" @click="chooseCategoty(item2)">
                    {{ item2.attribute_value }}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- 套餐选择模块 -->
          <div class="skuTitle">
            <p>选择套餐 {{ showSkuList.length ? '(' + showSkuList.length + ')' : '' }}</p>
          </div>

          <div class="skuGroup ">
            <template v-if="showSkuList.length">
              <div class="skuName" :class="activeSku == item.id ? 'skuSelected' : ''"
                v-for="(item, index) in showSkuList" :key="index" @click="chooseSku(item)">
                {{ item.name }}
              </div>
            </template>
            <template v-else>
              <div class="skuName noneMatch">无匹配套餐</div>
            </template>
          </div>

          <ul>
            <li>
              <span>数量选择</span>
              <div class="count">
                <el-popover placement="bottom-start" size="small" title="价格提示" width="100" trigger="hover"
                  :content="submit.day ? '¥' + submit.day.adult_price : '请选择日期'">
                  <span slot="reference">出行人数</span>
                </el-popover>
                <el-input-number v-model="quantityVal" size="small" :min="0" :step="1"></el-input-number>
              </div>
            </li>
            <li class="total">
              <p><span>总价:</span>
                <b class="price"
                  v-if="Object.keys(selectedSkuInfo).length && selectedDate && estimateSKU_with_SelectedDate()">
                  <!-- {{ getTotal }} -->
                  {{ sum_Price }}
                </b>
              </p>
              <button @click="addOrder">立即预订</button>
              <!-- <button>立即预订</button> -->
            </li>
          </ul>
        </div>
      </section>

      <div class="detail">
        <!-- 滑动模块 -->
        <nav class="groupTopWrap">
          <span class="groupTitle" v-for="(item, index) in scrollDataList" :key="index" @click="toDom(index)"
            :class="{ on: getScrollIndex === Number(index) }">
            {{ item.typeTitle }}
          </span>
        </nav>

        <!-- 底部产品详情 富文本等相关展示内容 -->
        <ul class="content">

          <li class="sc_ItemWrap" v-for="(item, index) in scrollDataList" :key="index" :id="item.scrollID">
            <h4 class="sc_Title" :id="'nodes' + Number(index)">{{ item.typeTitle }}</h4>
            <div class="richContent">
              <!-- 富文本模块 -->
              <div class="nodes" v-html="item.bodyhtml"> </div>

              <!-- 附件图片 -->
              <template v-if="item.img_https && item.img_https.length">
                <div class="agreementImageWrap">
                  <img @tap.stop="showAgreeImage(item.img_https)" :src="item.img_https">
                </div>
              </template>

              <!-- 附件文件 -->
              <template v-if="item.annex_https && item.annex_https.length">
                <div class="agreementFileWrap flex-h-cc">
                  <span class="icon iconfont icon-sousuo"></span>
                  <div class="agreeText">查看 附件文件</div>
                </div>
              </template>
            </div>
          </li>

        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="showDialog" custom-class="pop" width="1000px" :title="dialog.title">
      <div class="cont">
        <el-carousel class="pic" width="600px" height="400px">
          <el-carousel-item v-for="v in dialogImgs" :key="v">
            <img :src="v" alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="nodes" v-html='dialog.content_html'></div>
      </div>
    </el-dialog>
  </main>
</template>

<script>
import $tour from '@api/tour';
import moment from 'moment';
import { mapState } from "vuex";
import dayjs from '@assets/js/day';
export default {
  data() {
    return {
      productInfo: {},
      selectedAttrList: [], //选中的属性值的ID数组
      selectedSkuInfo: {}, //选中的套餐
      activeSku: '', //选中的SKU的ID 默认为 : sku列表的第一项的ID
      categotyList: [], //选中SKU的 子属性列表 ,可能为空; 默认为 :sku列表下的attrs 或者为[];
      skus: [], //sku列表
      sku_attribute_value: [], //SKU 所有属性列表.
      shrinkStatus: false, //概述的展开模式 默认不展开
      selectedDate: '', //日历组件选择的日期
      dayPrice: [], //每日的价格列表
      quantityVal: 1, //购买数量 默认为0
      showSkuList: [],
      cover_urlList: [], //图片数组
      scrollDataList: [], //scrollview内部的内容
      actAnchorID: '', //滑动至某项的ID
      groupTopWrapHeight: 0,
      allScrollWrapKey: [], //所有滑动数组项的 ID集合
      scrollTimmer: null,
      fileIdentify: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'], //可预览的文件类型
      skus: {},
      info: {},
      tourGroups: [],
      submit: {
        month: 0,
        day: null,
        adult: 1,
        child: 0,
      },
      top: 0,
      strokeShowType: 0,
      showDialog: false,
      dialog: {},

      weekList: ['一', '二', '三', '四', '五', '六', '日'],
      monthList: [],
      yearList: [],
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      show_Year: new Date().getFullYear(), //展示的年
      show_Month: new Date().getMonth() + 1, //展示的月份
      dayList: [],
      contentType: 'dayType', // "dayType","monthType","yearType"
      inlineCalanderData: [] //行内日历的日期列表
    }
  },
  watch: {
    dayPrice: {
      handler(param, oldParam) {
        let _this = this;
        // 当有新的价格时,重置日期
        if (oldParam && oldParam.length) {
          _this.show_Year = new Date().getFullYear();
          _this.show_Month = new Date().getMonth() + 1;
          _this.$nextTick(async () => {
            await _this.getDayInfo();
          });
        }

        if (param && param.length) {
          _this.$nextTick(async () => {
            await _this.getDayInfo();
          });
          let timmer = setInterval(() => {
            if (_this.dayList && _this.dayList.length) {
              clearInterval(timmer);
              _this.setDayListWithPrice(); //设置每天的价格
            }
          }, 50);
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    // 展示的套餐的价格
    retailPrice() {
      let _this = this;
      if (!Object.keys(_this.selectedSkuInfo).length) return;
      let priceNum = _this.GetPriceByIdentity(_this.selectedSkuInfo.retail_price, _this.selectedSkuInfo
        .dealer_price);
      return priceNum;
    },
    // 计算订单总价
    sum_Price() {
      let _this = this;
      if (!_this.retailPrice) return;
      let sumNum = (_this.retailPrice * _this.quantityVal).toFixed(2);
      return sumNum;
    },
    getTotal() {
      const { day, adult, child } = this.submit;
      if (!day) { return '--'; }
      const { adult_price, child_price } = day;
      return parseFloat((adult_price * adult + child_price * child).toFixed(2));
    },
    getGroups() {
      const { month } = this.submit;
      const obj = this.tourGroups[month];
      return obj ? obj.date : [];
    },
    dialogImgs() {
      const { pic_arr } = this.dialog;
      if (!pic_arr) { return []; }
      return pic_arr.split(',').map(v => this.imgUrl + v);
    },
    imgs() {
      const { pics } = this.info;
      if (!pics) { return []; }
      return pics.split(',').map(v => this.imgUrl + v);
    },
    getScrollIndex() {
      const { top } = this;
      if (document.querySelector('#nodes0') === null) { return; }
      const ids = [...['nodes0', 'nodes1'], ...(this.info.travel_notices || []).map((v, i) => 'nodes' + (i + 2))];
      const y = ids.map((v, i) => {
        const dom = document.querySelector(`#${v}`);
        return {
          top: dom ? dom.offsetTop : 1000000,
          index: i
        }
      }).reverse();
      const r = y.find(v => top > v.top - 45);
      const index = r ? r.index : 0;
      return index;
    },
  },
  filters: {
    checkFood(val) {
      return val === '1' ? 'icon-gou' : 'icon-clear';
    }
  },
  created() {
    const { id } = this.$route.params;
    this.getProductData(id); //通过ID 获取旅游产品详情
    this.scrollTo(0, false);
    window.addEventListener('scroll', this.bodyScroll);
  },
  methods: {

    openDialog(v) {
      this.dialog = v;
      this.showDialog = true;
    },
    bodyScroll() {
      const top = document.documentElement.scrollTop;
      this.top = top;
    },
    toDom(i) {
      const top = document.querySelector(`#nodes${i}`).offsetTop;
      this.scrollTo(top - 43);
    },
    // 立即预定
    addOrder() {

      let _this = this;

      const sku_id = _this.selectedSkuInfo.id;
      const sku_quantity = _this.quantityVal;
      const sku_travel_date = _this.selectedDate;

      //单价
      let unit_price = _this.GetPriceByIdentity(_this.selectedSkuInfo.retail_price, _this.selectedSkuInfo.dealer_price);
      unit_price = Number(unit_price).toFixed(2);
      if (!sku_id) {
        _this.$message.warning('请选择套餐!');
        return;
      }
      if (!sku_quantity) {
        _this.$message.warning('请选择购买数量!');
        return;
      }
      if (!sku_travel_date) {
        _this.$message.warning('请选择出行日期!');
        return;
      }

      let pre_OrderInfo = {
        sku_id,
        sku_quantity,
        sku_travel_date,
        productInfo: _this.productInfo,
        SkuInfoName: _this.selectedSkuInfo.name,
        unit_price,
        selectedSkuInfo: _this.selectedSkuInfo
      };

      sessionStorage.setItem('tourOrder', JSON.stringify(pre_OrderInfo));
      this.$router.push({
        name: "tour_add",
      });
    },
    getTourGroups() {
      const { info } = this;
      if (info.tourgroups.length === 0) {
        const y = moment().get('year');
        const m = moment().get('month');
        const maxDay = moment().endOf('month').format('DD');
        const minWeekday = moment().startOf('month').weekday();
        const date = [
          ...Array.from({ length: minWeekday }, () => ({ on: false, day: null })),
          ...Array.from({ length: maxDay }, (x, i) => ({ day: i + 1, on: false }))
        ];
        let tourGroups = [{ y, m, date }];
        this.tourGroups = tourGroups;
        return;
      }
      // 重组日历函数，按月分组
      let tourGroups = info.tourgroups.reduce((arr, v) => {
        const y = moment(v.departure_date).get('year');
        const m = moment(v.departure_date).get('month');
        const i = arr.findIndex(v => v.y === y && v.m === m);
        const v2 = {
          ...v,
          adult_price: v.adult_price || info.adult_price,
          child_price: v.child_price || info.child_price,
          need_passport: info.need_passport,
          tour_days: info.tour_days,
          city_text: info.city_text
        }
        if (i === -1) {
          arr.push({ y, m, minPrice: v2.adult_price, date: [v2] });
        } else {
          if (v2.adult_price < arr[i].minPrice) {
            arr[i].minPrice = v2.adult_price;
          }
          arr[i].date.push(v2);
        }
        return arr;
      }, [])
        // 填充当月完整日历，匹配对应日期的信息
        .map(v => {
          const date = moment(v.date[0].departure_date);
          const maxDay = date.endOf('month').format('DD');
          const minWeekday = date.startOf('month').weekday();
          const days = v.date.map(v => Number(v.departure_date.split('-')[2]));
          let months = Array.from({ length: maxDay }, (x, i) => ({ day: i + 1, on: false })).map(s => {
            const i = days.findIndex(d => d === s.day);
            return i === -1 ? s : { ...s, on: true, ...v.date[i], y: v.y, m: v.m };
          });
          months = [...Array.from({ length: minWeekday % 7 }, () => ({ day: '', on: false })), ...months];
          v.date = months;
          return v;
        });
      this.tourGroups = tourGroups;
    },
    changeSubmit(attr, val) {
      const submit = { ...this.submit, [attr]: val };
      this.submit = submit;
    },
    changeDay(item) {
      const { on } = item;
      if (!on) { return; }
      this.changeSubmit('day', item);
    },
    // 设置滑动项的ID
    setScrollID(scrollGroupID) {
      let _this = this;
      _this.actAnchorID = scrollGroupID;
    },
    // 通过 选择的套餐 , 以及选择的日期,判断 套餐是否有效
    estimateSKU_with_SelectedDate() {
      let _this = this;
      let skuStatus = true; // 默认 false;

      if (Object.keys(_this.selectedSkuInfo).length && _this.selectedDate) {
        let dayPriceList = _this.dayPrice;
        for (let item in dayPriceList) {
          if (dayPriceList[item].hasDateAttr) {
            if (dayPriceList[item].is_exclud == 1) {
              if (dayPriceList[item].description.includes(_this.selectedDate)) {
                skuStatus = false;
                break;
              }
            } else if (dayPriceList[item].is_exclud == null) {
              if (!dayPriceList[item].description.includes(_this.selectedDate)) {
                skuStatus = false;
                break;
              }
            }
          }
        }
      } else {
        return false;
      }
      return skuStatus;
    },

    // 将数字转为 正常显示的价格
    ConversionPrice(price) {
      return price ? (Number(price) / 100).toFixed(2) : 0;
    },

    GetPriceByIdentity(retail_price, dealer_price) {
      let _this = this;
      const userInfo = _this.userInfo;
      let price = retail_price; //默认输出零售价,当进入身份判断时,返回判断后的价格 || 零售价;
      if (userInfo && Object.keys(userInfo).length) {
        const {
          identify
        } = userInfo;

        if (identify.includes('staff') || identify.includes('distribution')) {
          price = dealer_price;
        }
      }
      return _this.ConversionPrice(price);
    },
    // 携带相关参数至 订单页面
    navProductOrder() {
      let _this = this;

      const sku_id = _this.selectedSkuInfo.id;
      const sku_quantity = _this.quantityVal;
      const sku_travel_date = _this.selectedDate;

      //单价
      let unit_price = _this.GetPriceByIdentity(_this.selectedSkuInfo.retail_price, _this.selectedSkuInfo.dealer_price);
      unit_price = Number(unit_price / 100).toFixed(2);

      let pre_OrderInfo = {
        sku_id,
        sku_quantity,
        sku_travel_date,
        productInfo: _this.productInfo,
        SkuInfoName: _this.selectedSkuInfo.name,
        unit_price,
        selectedSkuInfo: _this.selectedSkuInfo
      };

      if (Object.values(pre_OrderInfo).length < 4) {
        uni.showToast({
          title: '缺少相关参数!',
          icon: 'none'
        });
        return;
      }

      uni.setStorage({
        key: 'travelPreOrderInfo',
        data: pre_OrderInfo,
        success() {
          uni.navigateTo({
            url: '/pages_travel/travel/productOrder/index'
          });
        }
      });
    },
    // 修改 商品购买数量
    changeQuantity(type) {
      let _this = this;
      let quantityVal = _this.quantityVal;
      if (type == 'add') {
        quantityVal += 1;
      } else {
        if (quantityVal <= 1) {
          uni.showToast({
            title: '不能再少了！',
            icon: 'none'
          });
          return;
        } else {
          quantityVal -= 1;
        }
      }

      _this.quantityVal = quantityVal;
    },
    // 打开日历
    showCalendar() {
      let _this = this;
      _this.$refs.cscalendar.showCalendar();
    },
    //设置展开/收缩的状态
    setShrinkStatus() {
      let _this = this;
      _this.shrinkStatus = !_this.shrinkStatus;
    },
    // 判断 套餐是否能显示
    checkSkuShowStatus(itemData) {
      let _this = this;
      let showStatus = false;
      const { attribute_value_ids } = itemData;

      // 没有自定义属性值时 默认显示
      if (!_this.selectedAttrList.length) {
        return true;
      }

      if (_this.selectedAttrList.length && attribute_value_ids.length) {
        if (_this.selectedAttrList.length <= 1) {
          for (let i = 0; i < attribute_value_ids.length; i++) {
            let isIncludes =
              _this.selectedAttrList.find(item2 => {
                return item2.id == attribute_value_ids[i];
              }) || {};
            if (Object.keys(isIncludes).length) {
              showStatus = true;
              break;
            }
          }
        } else {
          let allIDList = [];
          _this.selectedAttrList.map(item => {
            allIDList.push(item.id);
          });

          allIDList = _this.sortArray(allIDList);
          allIDList = allIDList.join(',');

          let attrList = _this.sortArray(attribute_value_ids);
          attrList = attrList.join(',');
          showStatus = attrList.includes(allIDList);
        }
      }
      return showStatus;
    },
    // 判断属性值 是否能展示已勾选
    getArrtClass(data) {
      let _this = this;
      let status = false;
      const { id } = data;

      const finnalStatus =
        _this.selectedAttrList.find(item => {
          return item.id == id;
        }) || {};

      if (Object.keys(finnalStatus).length) {
        status = true;
      }
      return status;
    },

    // 点击查看政策相关内的图片
    showAgreeImage(url) {
      let _this = this;
      uni.previewImage({
        current: 0,
        urls: [url]
      });
    },
    // 检测 是否图片/文件的类型
    checkFileType(paramUrl, checkType) {
      let status = false;
      let testUrl = paramUrl
        .split('.')
        .reverse()
        .join('.');
      status =
        checkType.filter(item => {
          return testUrl.includes(item);
        }).length >= 1
          ? true
          : false;
      return status;
    },

    // 点击查看轮播图
    previewImg(index) {
      let _this = this;
      uni.previewImage({
        current: index,
        urls: _this.cover_urlList
      });
    },
    // 初始化选中的内容 , 用于勾选 子属性后的数值渲染
    initChooseInfo() {
      let _this = this;
      _this.activeSku = ''; //清除选中的
      _this.selectedSkuInfo = {};
      _this.quantityVal = 1;
    },
    // 选择SKU
    chooseSku(item) {
      let _this = this;
      _this.activeSku = item.id;
      _this.selectedSkuInfo = item;
      _this.setDateInfo([item], _this.sku_attribute_value); //设置日期相关参数
      _this.estimateSKU_with_SelectedDate();
    },

    // 选择子属性
    chooseCategoty(item) {
      let _this = this;
      const { id, attribute_id } = item;
      _this.initChooseInfo(); //初始化选中的值
      let list = _this.selectedAttrList;
      if (list.length) {
        // 是否有相同属性ID
        const HasSameAttr =
          list.find(item => {
            return item.id == id;
          }) || {};

        // 是否有相同属性类型
        const HasSameAttrType =
          list.find(item => {
            return item.attribute_id == attribute_id;
          }) || {};

        if (Object.keys(HasSameAttrType).length && !Object.keys(HasSameAttr).length) {
          for (let i in list) {
            if (list[i]['attribute_id'] == attribute_id) {
              list.splice(i, 1, { id, attribute_id });
            }
          }
          _this.selectedAttrList = list;
          _this.setCountPrice(list); //设置需要展示的价格数组
          return;
        }

        // 当 有相同的属性ID时,向数组内删除一组数据
        if (Object.keys(HasSameAttr).length) {
          for (let i in list) {
            if (list[i]['id'] == id) {
              list.splice(i, 1);
            }
          }
        } else {
          list.push({
            id,
            attribute_id
          });
        }
      } else {
        list.push({
          id,
          attribute_id
        });
      }

      _this.selectedAttrList = list;

      _this.setCountPrice(list); //设置需要展示的价格数组
    },
    // 设置需要展示的价格数组
    setCountPrice(idlist) {
      let _this = this;
      let sku_List = _this.skus;
      let showSkuList = [];

      if (!idlist.length) {
        _this.showSkuList = _this.skus;
        return;
      }

      if (idlist.length <= 1) {
        for (let i = 0; i < sku_List.length; i++) {
          for (let x = 0; x < idlist.length; x++) {
            if (sku_List[i].attribute_value_ids.includes(idlist[x]['id']) || !sku_List[i].attribute_value_ids.length) {
              showSkuList.push(sku_List[i]);
            } else {
              break;
            }
          }
        }
      } else {
        let allIDList = [];
        idlist.map(item => {
          allIDList.push(item.id);
        });
        allIDList = _this.sortArray(allIDList);
        allIDList = allIDList.join(',');
        sku_List.map(item => {
          if (item.attribute_value_ids.length) {
            let attrList = _this.sortArray(item.attribute_value_ids);
            attrList = attrList.join(',');

            if (attrList.includes(allIDList)) {
              showSkuList.push(item);
            }
          } else {
            showSkuList.push(item); //没有attribute_value_ids值
          }
        });
      }
      showSkuList = Array.from(new Set(showSkuList));
      _this.showSkuList = showSkuList;
      _this.setDateInfo(showSkuList, _this.sku_attribute_value); //设置日期相关参数
    },
    sortArray(list) {
      let listdata = list.sort((a, b) => {
        return a - b;
      });
      return listdata;
    },



    // 通过 attribute_value_ids属性值列表,从  sku_attribute_value所有属性中 返回  相对应的属性值
    findChildByList(listData) {
      let _this = this;
      let returnList = [];
      if (listData && listData.length) {
        listData.map(item => {
          _this.sku_attribute_value.map(item2 => {
            if (item2.sku_attribute_values && item2.sku_attribute_values.length) {
              const findItems =
                item2.sku_attribute_values.find(findItem => {
                  return item === findItem.id;
                }) || {};
              if (Object.keys(findItems).length) {
                returnList.push(findItems);
              }
            }
          });
        });
      }
      return returnList;
    },

    // 获取 产品信息
    async getProductData(id) {
      let _this = this;
      await $tour.getTravelDetailById(id).then((res) => {
        _this.sku_attribute_value = res.data.sku_attribute_value;
        _this.productInfo = res.data.spu;
        if (res.data.spu && res.data.spu.cover_url) {
          _this.cover_urlList = Array.isArray(res.data.spu.cover_url) ? res.data.spu.cover_url : [res.data.spu.cover_url];
        }
        res.data.skus.map(item => {
          let itemAttrs_id = [];

          if (item.attrs.length) {
            item.attrs.map(item2 => {
              itemAttrs_id.push(item2.attribute_id);
            });
          }
          item.attrs_idList = itemAttrs_id;
        });

        _this.skus = res.data.skus;
        _this.showSkuList = res.data.skus;

        _this.setDateInfo(res.data.skus, res.data.sku_attribute_value); //设置日期相关参数

        // 设置 滑动列表内容
        let proDesc = res.data.spu.description && res.data.spu.description.description ? res.data.spu.description : {};
        let terms = res.data.spu.terms && res.data.spu.terms.length ? res.data.spu.terms : [];
        let detailItem = {};
        if (proDesc && Object.keys(proDesc).length) {
          _this.actAnchorID = 'scrollGroup_0'; //设置默认的 滑动ID
          proDesc.description = _this.richTextTransform(proDesc.description);

          detailItem = {
            bodyhtml: proDesc.description,
            typeTitle: '产品详情'
          };
        }

        if (terms && terms.length) {
          terms.map(item => {
            item.scrollID = 'scrollGroup_' + item.id;
            item.typeTitle = item.title;
          });
        }

        // 有产品详情,有协议条款
        if (terms.length) {
          if (Object.keys(detailItem).length) {
            terms.unshift(detailItem);
          }

          let allItemsKeyList = [];
          terms.map((item, index) => {
            item.scrollID = 'scrollGroup_' + index;
            allItemsKeyList.push(item.scrollID);
          });
          _this.allScrollWrapKey = allItemsKeyList.reverse();
          _this.scrollDataList = terms;
        }

        // 有产品详情,无 协议条款
        if (Object.keys(detailItem).length && !terms.length) {
          terms.unshift(detailItem);

          let allItemsKeyList = [];
          terms.map((item, index) => {
            item.scrollID = 'scrollGroup_' + index;
            allItemsKeyList.push(item.scrollID);
          });
          _this.allScrollWrapKey = allItemsKeyList.reverse();
          _this.scrollDataList = terms;
        }

      });

    },
    // 设置富文本内容
    richTextTransform(data) {
      return data
        .replace(/\r|\n/g, '')
        .replace(/&ldquo;/g, '“')
        .replace(/&mdash;/g, '-')
        .replace(/&rdquo;/g, '”')
        .replace(/\r|\n/g, '')
        .replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/g, '')
        .replace(/&ldquo;/g, '“')
        .replace(/&mdash;/g, '-')
        .replace(/&rdquo;/g, '”')
        .replace(/<img/g, "<img style='width:100%;max-width:100%;height:auto;' ")
        .replace(/<figure class="image">/g, '')
        .replace(/<\/figure>/g, '')
        .replaceAll(`src="//oa`, `src="https://oa`)
        .replaceAll(`src="/public`, `src="https://imgsaas.cstravel.cn`);
    },
    // 设置日期相关参数
    setDateInfo(data, sku_attribute_value) {
      let _this = this;
      let priceArrt = [];

      data.map(item => {
        // 属于日期特征的某一项
        const DateAttrItem =
          item.attrs.find(childItem => {
            return childItem.attribute_id === 33;
          }) || {};

        // 判断是否拥有日期特征
        const hasDateAttr =
          item.attrs_idList.find(childItem => {
            return childItem === 33;
          }) || false;

        let dateAttrValueId = '';

        if (hasDateAttr) {
          dateAttrValueId = DateAttrItem.attribute_value_id;
        }
        priceArrt.push({
          hasDateAttr: hasDateAttr ? true : false,
          // retail_price: item.retail_price,
          retail_price: _this.GetPriceByIdentity(item.retail_price, item.dealer_price),
          dateAttrValueId,
          start_time: item.start_time,
          end_time: item.end_time
        });
      });

      let all_sku_attribute = []; //获取所有的子属性值

      sku_attribute_value.map(item => {
        all_sku_attribute.push(...item.sku_attribute_values);
      });

      priceArrt.map(item => {
        if (item.dateAttrValueId) {
          all_sku_attribute.map(item2 => {
            if (item2.id == item.dateAttrValueId) {
              item.is_exclud = item2.is_exclud;
              item.description = item2.description;
            }
          });
        }
      });
      _this.dayPrice = priceArrt;
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.bodyScroll);
    },
    // 通过某个指定月份,设置 当月日历
    async getDayInfo() {
      let _this = this;
      const year = _this.show_Year || dayjs(new Date()).format('YYYY');
      let month = _this.show_Month || dayjs(new Date()).format('MM');
      month = month < 10 ? '0' + month : month;

      let currentDateInfo = (await _this.getMonthDayLength(year + '-' + month + '-01')) || {};
      if (Object.keys(currentDateInfo).length) {
        let { year, month, days } = currentDateInfo;
        month = month < 10 ? '0' + month : month;
        let list = [];

        for (let i = 1; i < days + 1; i++) {
          const strDay = Number(i) < 10 ? '0' + i : i;
          const date = year + '-' + month + '-' + strDay;
          const weekDay = new Date(date).getDay();
          list.push({
            day: i,
            date,
            weekDay: weekDay ? weekDay : 7
          });
        }

        // 该月份的1号不是周一时,需要补足上月份的日期
        if (list[0]['weekDay'] != 1) {
          const addFakeDay = list[0]['weekDay'] - 1;
          let fakeList = [];
          for (let i = 0; i < addFakeDay; i++) {
            fakeList.push({
              day: '',
              date: '',
              weekDay: ''
            });
          }

          list.unshift(...fakeList);
        }

        _this.dayList = list;
        _this.setDayListWithPrice();
      }
    },
    // 通过 某个指定月份 ,获取当月的总天数
    // targetMonth 不传值时，获取当前月的总天数
    async getMonthDayLength(targetMonth) {
      return new Promise(resolve => {
        const date = new Date(targetMonth);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const days = new Date(year, month, 0).getDate();
        resolve({ year, month, days });
      });
    },
    // 传入 年-月-日 返回 月+日
    getDateByFullString(param) {
      let paramList = param.split('-');
      return paramList[1] + '-' + paramList[2];
    },
    // 设置每日价格
    setDayListWithPrice() {
      let _this = this;
      const todayDate = dayjs(new Date()).format('YYYY-MM-DD');

      let customDayList = _this.dayList;
      for (let i in customDayList) {
        if (customDayList[i]['date']) {
          const { date } = customDayList[i];
          customDayList[i]['isBeforeToday'] = _this.TimeBeforeToday(date);

          // 判断是否当天, 如果当天的话,价格可选
          if (date == todayDate) {
            customDayList[i]['isBeforeToday'] = false;
          }
          const dateMinPrice = _this.setMinPriceByDate(date);
          customDayList[i]['price'] = dateMinPrice || 0;
        }
      }

      _this.dayList = customDayList;
      // 价格改变时,设置行内的价格
      let copyList = JSON.parse(JSON.stringify(customDayList));
      let fakeList = [];
      if (copyList && copyList.length) {
        copyList.map((item, index) => {
          if (item.date && !item.isBeforeToday && item.price) {
            fakeList.push(item);
          }
        });
      }

      if (fakeList.length) {
        _this.inlineCalanderData = _this.calculateInlineDate(dayjs(new Date()).format('YYYY-MM-DD'));
      }
    },
    // 通过已选择的日期,返回行内 7天的日期数组   judgeDate:判断的日期
    calculateInlineDate(judgeDate) {
      let _this = this;
      let returnInlineList = []; // 需要返回的日历
      const selectedStr = judgeDate; //当前选择的日期
      const isInDayList = _this.inlineCalanderData.find(item => {
        return item.date == selectedStr;
      });
      // 判断选中日期是否在展示的行内列表内
      if (isInDayList) {
        returnInlineList = _this.inlineCalanderData;
      } else {
        let tagetMonthList = [];
        tagetMonthList = _this.setAfterDateList(selectedStr);
        returnInlineList = tagetMonthList;
      }
      return returnInlineList;
    },
    // 通过日期,返回该日期之后的当月的日期列表
    setAfterDateList(dateStr) {
      let _this = this;
      const targetMonthDaysLength = dayjs(dateStr).daysInMonth(); //所选月的日期总长度;

      const targetYear = dayjs(dateStr).format('YYYY');
      const targetMonth = dayjs(dateStr).format('MM');

      let additionDateList = [];
      for (let i = 0; i < targetMonthDaysLength; i++) {
        let item_Day = Number(i) + 1 < 10 ? '0' + (Number(i) + 1) : Number(i) + 1;
        const item_Date = targetYear + '-' + targetMonth + '-' + item_Day;
        additionDateList.push({
          day: Number(item_Day),
          date: item_Date,
          weekDay: dayjs(item_Date).day(),
          isBeforeToday: _this.TimeBeforeToday(item_Date),
          price: _this.setMinPriceByDate(item_Date)
        });
      }

      // 通过日期,截取生成的日历
      const splitIndex = additionDateList.findIndex(item => {
        return item.date == dateStr;
      });
      additionDateList = additionDateList.splice(splitIndex, additionDateList.length);

      let finalList = [];
      additionDateList.map((item, index) => {
        if (item.date && !item.isBeforeToday && item.price) {
          finalList.push(item);
        }
      });

      if (finalList.length >= 7) {
        finalList = finalList.splice(0, 7);
      } else {
        const extraDate = dayjs(targetYear + '-' + targetMonth + '-' + '01')
          .add(1, 'month')
          .format('YYYY-MM-DD');
        let extraList = _this.setAfterDateList(extraDate);
        finalList = [...finalList, ...extraList];
        finalList = finalList.splice(0, 7);
      }
      return finalList;
    },
    // 获取当日最便宜的价格
    setMinPriceByDate(date_str) {
      let _this = this;
      let priceList = [];

      _this.dayPrice.map(item => {
        // 1:判断是否在生效日期之后
        const startStatus = item.start_time ? _this.TimeBeforeToday(item.start_time) : true;
        // 2:判断是否在结束时间之前
        const endStatus = item.end_time ? !_this.TimeBeforeToday(item.end_time) : true;
        if (startStatus && endStatus) {
          // 没有自定义属性
          if (!item.hasDateAttr) {
            priceList.push(item.retail_price);
          } else {
            // 包含自定义属性值
            if (item.is_exclud == 1) {
              if (!item.description.includes(date_str)) {
                priceList.push(item.retail_price);
              }
            } else if (item.is_exclud == null) {
              if (item.description.includes(date_str)) {
                priceList.push(item.retail_price);
              }
            }
          }
        }
      });

      let minPrice = priceList && priceList.length ? Math.min(...priceList) : 0;
      // minPrice = minPrice ? minPrice / 100 : 0;
      return minPrice;
    },
    // 传入一个 时间,判断传入时间是否在当前时间之前 
    // countDay:yyy-mmm-ddd h:m:s 格式的时间;
    TimeBeforeToday(countDay) {
      let dateBegin = new Date(countDay.replace(/-/g, "/")); //将-转化为/，使用new Date
      const startTimeSecond = dateBegin.getTime();
      const currentTimeSecond = new Date().getTime();
      return currentTimeSecond >= startTimeSecond;
    },
    // 点击选择日期
    chooseDate(item) {
      if (!item.price || item.isBeforeToday) return;
      let _this = this;
      _this.selectedDate = item;
    },
    // 点击切换至 上个月
    setLastMonth() {
      let _this = this;
      let show_Year = Number(_this.show_Year),
        show_Month = Number(_this.show_Month);

      if (show_Month - 1 < 1) {
        show_Month = 12;
        show_Year -= 1;
      } else {
        show_Month -= 1;
      }
      _this.show_Month = show_Month;
      _this.show_Year = show_Year;
      _this.getDayInfo();
    },
    // 点击切换至 下个月
    setNextMonth() {
      let _this = this;
      let show_Year = Number(_this.show_Year),
        show_Month = Number(_this.show_Month);

      if (show_Month + 1 > 12) {
        show_Month = 1;
        show_Year += 1;
      } else {
        show_Month += 1;
      }
      _this.show_Month = show_Month;
      _this.show_Year = show_Year;
      _this.getDayInfo();
    },
    // ---------------------------------------------------------------
  },

}
</script>

<style src="./detail.css"></style>